export default "__VITE_ASSET__ZxB2MxqV__"